import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Paper,
  Tabs,
  Tab
} from '@mui/material';

interface DocumentTabsProps {
  tabValue: number;
  onTabChange: (event: React.SyntheticEvent, newValue: number) => void;
}

export const DocumentTabs: React.FC<DocumentTabsProps> = ({
  tabValue,
  onTabChange
}) => {
  const { t } = useTranslation();

  return (
    <Paper sx={{ mb: 3 }}>
      <Tabs
        value={tabValue}
        onChange={onTabChange}
        indicatorColor="primary"
        textColor="primary"
        variant="fullWidth"
      >
        <Tab label={t('documents.tabs.allDocuments')} />
        <Tab label={t('documents.tabs.myDocuments')} />
        <Tab label={t('documents.tabs.sharedWithMe')} />
{/*
        <Tab label={t('documents.tabs.sapDocumentation')} />
        <Tab label={t('documents.tabs.customDocuments')} />
        <Tab label={t('documents.tabs.documentSources')} /> */}
      </Tabs>
    </Paper>
  );
};